module.exports = __webpack_public_path__ + "assets/img/footer1.dc4523d7.png";